/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    _VDF_: {
      debug: () => void;
      debugToFile: () => void;
    };
  }
}

const LOCAL_STORAGE_DEBUG_KEY = "debug-info";
const TRANSACTIONS_AMOUNT_TO_STORE = 5;

const getDebugInfo = () => {
  const debugInfo = window.localStorage.getItem(LOCAL_STORAGE_DEBUG_KEY);

  try {
    return debugInfo ? JSON.parse(debugInfo) : {};
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const setDebugInfo = (key: string, value: object) => {
  const debugInfo = getDebugInfo();
  debugInfo[key] = value;
  window.localStorage.setItem(LOCAL_STORAGE_DEBUG_KEY, JSON.stringify(debugInfo));
};

export const setDebugSubject = (subject: any) => setDebugInfo("subject", subject);

export const setDebugTransactions = (transactionObj: any) => {
  const debugInfo = getDebugInfo();

  if (!debugInfo.transactions) {
    debugInfo.transactions = [transactionObj];
  } else if (debugInfo.transactions.length < TRANSACTIONS_AMOUNT_TO_STORE) {
    debugInfo.transactions.push(transactionObj);
  } else {
    debugInfo.transactions.pop();
    debugInfo.transactions.push(transactionObj);
  }

  window.localStorage.setItem(LOCAL_STORAGE_DEBUG_KEY, JSON.stringify(debugInfo));
};

const debug = () => {
  const now = new Date();
  const debugInfo = getDebugInfo();
  console.log(
    "🚀🚀 Send the following text to your awesome 💪DEV💪 team 👉👉 ",
    JSON.stringify({ ...debugInfo, debugTime: now.toISOString() }),
  );
};

const debugToFile = () => {
  const now = new Date();
  const a = document.createElement("a");
  const debugInfo = { ...getDebugInfo(), debugTime: now.toISOString() };
  const file = new Blob([JSON.stringify(debugInfo)], { type: "text/plain" });
  const url = URL.createObjectURL(file);
  a.href = url;
  a.download = `bug_report_${now.toISOString()}.json`;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
};

const clearDebugInfo = () => {
  window.localStorage.setItem(LOCAL_STORAGE_DEBUG_KEY, "{}");
};

export const initDebug = () => {
  window._VDF_ = { debug, debugToFile };
  clearDebugInfo();
};
